import getDecorators from "inversify-inject-decorators";
import container from "../../ioc/inversify.config";
import TYPES from "../../ioc/types";
import { KeyboardMappingService } from "../../services/keyboardmapping-service";
import { DefaultHorizontalMenu } from "../components/base-menu";
import { ItemDescription } from "../components/inventory/item-description";
import { ShopItem } from "../components/inventory/shop-item";
import { GeometryService } from "../ui-services/geometry-ui-service";
import { DefaultEventService, EventService } from "../../services/event-service";
import { ItemDefinitionDTO } from "../../shared/dtos";

const { lazyInject } = getDecorators(container);

export class ShopMenu extends DefaultHorizontalMenu<ShopItem> {
    private items: Array<ItemDefinitionDTO>;

    public scene: Phaser.Scene;

    public itemDescription: ItemDescription;

    @lazyInject(TYPES.GeometryService)
    private geometryService: GeometryService;

    @lazyInject(TYPES.EventService)
    private eventService: DefaultEventService;

    @lazyInject(TYPES.KeyboardMappingService)
    private keyboardMappingService: KeyboardMappingService;

    constructor(
        x: number,
        y: number,
        width: number,
        height: number,
        items: Array<ItemDefinitionDTO>,
        scene: Phaser.Scene
    ) {
        super(scene, x, y);
        this.scene = scene;
        this.items = items;
        console.log("creating shop menu with items: ", items);
        const controls = this.keyboardMappingService.getKeyboardMapping("mikado");

        const screenWidth = this.scene.physics.world.bounds.width;
        const screenHeight = this.scene.physics.world.bounds.height;
        // probablement la hauteur du monde plutôt que de l'écran, ce qui entraîne ces calculs étranges
        // dans les positionnements des cards
        let itemX = 0;
        const itemY = 160;
        console.log("trying to draw at ", itemY);
        this.items.forEach((item, index) => {
            this.addMenuItem(new ShopItem(itemX, itemY, item, this.scene));
            itemX += screenWidth / 8;
        });
        if (this.menuItems && this.menuItems.length > 0) {
            this.menuItems[0].select();
            this.itemDescription = new ItemDescription(2, 0, this.items[0], this.scene);
        }
    }

    public refreshDescription() {
        const item = this.items[this.menuItemIndex];
        this.itemDescription.setDescription(item.description);
    }

    public draw() {
        const graphics = this.scene.add.graphics();

        this.geometryService.initGraphicContext(graphics);

        const screenWidth = this.scene.physics.world.bounds.width;
        const screenHeight = this.scene.physics.world.bounds.height;

        this.geometryService.drawBox(0, screenHeight - 100, screenWidth, screenHeight);

        //@ts-ignore
        const menu = this.scene.add.container();

        this.menuItems.forEach((item) => menu.add(item));
        if (this.menuItems.length > 0) {
            menu.add(this.itemDescription);
        }
    }

    public confirm() {
        console.log("trying to buy ", this.items[this.menuItemIndex].name);
        this.eventService.emit("buy_request", this.items[this.menuItemIndex].item_definition_id);
        //        this.scene.scene.setVisible(false);
        //        this.scene.scene.run(SceneId.MENU_SCENE, {mode: "item_mode", item: this.items[this.menuItemIndex]});
    }

    public onKeyInput(keyboardEvent: KeyboardEvent) {
        super.onKeyInput(keyboardEvent);
        if (this.menuItems.length > 0) {
            this.refreshDescription();
        }
    }
}
